import React, { useEffect, useState } from "react";
import { Box, LinearProgress, makeStyles, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";
import { actionTypes } from "../../../../../../redux/bourse/select_instruments";
import { useDispatch, useSelector } from "react-redux";
import { columns } from "./thead";
import ThbodyCustom from './thBody';
import { dateMiladiToShamsi } from "../../../../../method/date";
import Pagination from './../../../../../common/pagination/';

let useStyles = makeStyles((theme) => ({
    root: {
        width: '90%',
        minWidth: 1447,
        margin: 'auto',
        backgroundColor: 'white !important',
        // padding:'5px 0px'
        marginTop: 10,
        [theme.breakpoints.down("1550")]: {
            width: '100%',
            minWidth: '99%',
        },
    },
    gridTable: {
        width: '100%',
    },
    container: {
        '& table thead tr:nth-child(odd) th': {
            // backgroundColor:' #0B1742 !important',
            color: '#0B1742 !important'
        }
    },
    pagination: {
        margin: '30px 0px',
        '& .MuiPaginationItem-root': {
            backgroundColor: 'none',
            border: 'none',
            '&:hover': {
                backgroundColor: 'rgba(230,0,1,0.5)',
                color: '#ffffff',
            },
            '&.Mui-selected': {
                backgroundColor: '#E60001',
                color: '#ffffff',
                '&:hover': {
                    backgroundColor: '#E60001',
                },
            },
        },
    },
    noData: {
        height: 60,
        display: "flex",
        alignItems: "center",
        paddingLeft: 20,
    }
}))

let indexUser = 0


export default function Index({ state, flegApi, stock, setStock }) {

    let classes = useStyles();
    let dispatch = useDispatch();

    const [dataStock, setDataStock] = useState([]);

    const stateReducer = useSelector((state) => state.bourse_select_instruments_reducer);
    const [pagnation, setPagnation] = useState({
        number: 1,
        count: 2
    });


    const apiCallInstruments = (flag) => {
        let { size } = stateReducer;

        let obj = {};
        let from = pagnation?.number;

        Object.keys(state).forEach((element) => {
            if (state[element]) {
                obj[element] = state[element]?.['code'] ? state[element]?.['code'] : state[element];
            }
        });

        if (indexUser && (!obj?.from_date || !obj?.to_date) && !flag) {
            alert('فیلد های تاریخ اجباری می باشد ')
            return
        }

        if (obj?.from_date) {
            obj = {
                ...obj,
                from_date: dateMiladiToShamsi(obj?.from_date?.split(' ')?.[0])
            }
        }

        if (obj?.to_date) {
            obj = {
                ...obj,
                to_date: dateMiladiToShamsi(obj?.to_date?.split(' ')?.[0])
            }
        }

        if (obj?.commodity_id) {
            obj = {
                ...obj,
                commodity_id: +obj?.commodity_id?.data?.commodity_id
            }
        }

        if (obj?.manufacturer_id) {
            obj = {
                ...obj,
                manufacturer_id: +obj?.manufacturer_id?.data?.manufacturer_id
            }
        }

        // let data = { ...obj, currency_id: 1 };
        let data = { ...obj };

        dispatch({
            type: actionTypes.selectInstrumentsAsync,
            payload: { data, size, from },
        });
    };

    useEffect(() => {
        apiCallInstruments()
    }, [flegApi]);

    useEffect(() => {
        apiCallInstruments(true)
    }, [pagnation?.number]);


    // useEffect(() => {
    //     apiCallInstruments()
    // }, [state]);


    useEffect(() => {
        indexUser = ++indexUser
        return () => {
            dispatch({
                type: actionTypes.selectInstrumentsEmpty,
            });
            indexUser = 0
        };
    }, []);

    useEffect(() => {
        setDataStock(stateReducer?.data)
        setPagnation((prev) => ({
            ...prev,
            count: Math.ceil(stateReducer.total / stateReducer.size),
        }));
    }, [stateReducer]); //eslint-disable-line react-hooks/exhaustive-deps




    const handleLink = (text) => {
        return <div>پیوست</div>
    };

    const handelPagnation = (value) => {
        setPagnation((prev) => ({ ...prev, number: value }))

    }

    return (
        <div className={classes['root']}>
            <div style={{ height: 5, width: "100%", transform: "translateY(-5px)" }}>
                {stateReducer.loading && (
                    <LinearProgress style={{ width: "100%", color: "#009A44" }} />
                )}
            </div>
            <Paper className={classes.gridTable}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column, ind) => (
                                    <TableCell
                                        key={ind}
                                        align="center"
                                        style={{ width: 160, fontWeight: "bold" }}
                                        className="target"
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataStock?.map((info, index) => (
                                <ThbodyCustom
                                    key={index + info.id}
                                    index={index}
                                    info={info}
                                    handleLink={handleLink}
                                    stock={stock}
                                    setStock={setStock}
                                />
                            ))}
                            {(dataStock?.lenght === 0 || stateReducer.loading) && (
                                <tr>
                                    <td colSpan={16}>
                                        <div className={classes.noData}>
                                            {
                                                stateReducer.loading
                                                    ? 'در حال بارگذاری...'
                                                    : ' دیتایی برای نمایش وجو ندارد'
                                            }


                                        </div>
                                    </td>
                                </tr>
                            )}
                        </TableBody>
                    </Table>

                </TableContainer>


            </Paper>
            {
                pagnation.count >= 2 && (
                    <Pagination
                        className={classes['pagination']}
                        count={pagnation.count}
                        pagnation={pagnation.number}
                        setPagnation={(_data) => handelPagnation(_data)}
                    />
                )
            }
        </div>)
}
